import * as moment from 'moment';
export class Helpers {

    static tryParseDate(aDateString: string, format: string | null = null): Date | null {

        let aMoment: moment.Moment;
        if(format) {
            aMoment = moment(aDateString, format);
        } else {
            aMoment = moment(aDateString);
        }

        if (aMoment.isValid()) {
            return aMoment.toDate();
        }

        return null;

    }

    static chunk(array: Array<any>, size: number): Array<Array<any>> {

        if (!array) {
            return [];
        }

        if (array.length <= size) {
            return new Array<Array<any>>(array);
        }

        const loops = Math.ceil(array.length / size);
        const chunk: Array<Array<any>> = new Array();
        for (let index = 0; index <= loops; index++) {
            chunk.push(array.splice(0, size));
        }

        // const r = [firstChunk].concat(this.chunk(array.splice(size, array.length), size));
        return chunk;

    }

    static isArray(object: any): object is any[] {
        return Array.isArray(object);
    }

    static isBoolean(object: any): object is boolean {
        return typeof object === 'boolean';
    }

    static isNull(object: any): object is null {
        return object === null;
    }

    static isNullOrUndefined(arg: any) {
        return arg == null;
    }

    static isNumber(object: any): object is number {
        return typeof object === 'number';
    }

    static isString(object: any): object is string {
        return typeof object === 'string';
    }

    static isSymbol(object: any): object is symbol {
        return typeof object === 'symbol';
    }

    static isUndefined(object: any): object is undefined {
        return object === void 0;
    }

    static isRegExp(re: any) {
        return this.isObject(re) && this.objectToString(re) === '[object RegExp]';
    }

    static isObject(object: any): boolean {
        return typeof object === 'object' && object !== null;
    }

    static isDate(object: any): object is Date {
        return this.isObject(object) && this.objectToString(object) === '[object Date]';
    }

    static isError(object: any): object is Error {
        return this.isObject(object) && (this.objectToString(object) === '[object Error]' || object instanceof Error);
    }

    static objectToString(o: any): string {
        return Object.prototype.toString.call(o);
    }

    static isFunction(arg: any): boolean {
        return typeof arg === 'function';
    }

}